export default __webpack_public_path__ + "static/media/TNI-mobile-Gif1.9528ac3f.gif";